// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import SocialShareController from "./social_share_controller"
application.register("social-share", SocialShareController)

import TrixLinksController from "./trix_links_controller"
application.register("trix-links", TrixLinksController)

import TurboDialogController from "./turbo_dialog_controller"
application.register("turbo-dialog", TurboDialogController)

import Users__AddUserInterestsController from "./users/add_user_interests_controller"
application.register("users--add-user-interests", Users__AddUserInterestsController)

import Users__PasswordController from "./users/password_controller"
application.register("users--password", Users__PasswordController)

import Notification from '@stimulus-components/notification'
application.register('notification', Notification)

import Lightbox from "@stimulus-components/lightbox"
application.register('lightbox', Lightbox)

// Imported from Gov template: ./templates/stejar.templates.gov/app/javascripts/controllers
import LoadIframeController from "./load_iframe_controller"
application.register("load-iframe", LoadIframeController)

import PdfEmbedController from "./pdf_embed_controller"
application.register("pdf-embed", PdfEmbedController)
